// scroll the error div into view on a delay, offset the 60px header + 10px for a better UX
// Add focus for accessibility
export default function ScrollIntoView(elementId: string): string {
  const headerOffset = 70;

  if (typeof elementId === 'string') {
    const el = document.getElementById(elementId);

    if (el) {
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      el.focus();
    }
  }
  return elementId;
}
